document.querySelectorAll('[data-word-grid]').forEach((stage) => {
  const firstWord = stage.querySelector('.word-grid-word--first');
  const secondWord = stage.querySelector('.word-grid-word--second');

  if (!firstWord || !secondWord) {
    return;
  }

  const firstLength = Number(stage.dataset.firstLength);
  const secondLength = Number(stage.dataset.secondLength);
  const overlapLength = Number(stage.dataset.overlapLength);

  stage.style.gridTemplateColumns = `repeat(${firstLength + secondLength - overlapLength}, 1.8rem)`;
  firstWord.style.gridColumn = `1 / span ${firstLength}`;
  secondWord.style.gridColumn = `${firstLength - overlapLength + 1} / span ${secondLength}`;
});

document.querySelectorAll('[data-word-list]').forEach((list) => {
  const table = list.querySelector('.word-table');
  const rows = [...list.querySelectorAll('.word-row')];
  const sortButtons = [...list.querySelectorAll('.sort-btn')];
  const searchInput = list.querySelector('[data-word-search]');
  const postId = list.dataset.listId;

  if (!table || !searchInput || !postId) {
    return;
  }

  const updateLikeCount = (row, count) => {
    row.dataset.likes = String(count);
    const countElement = row.querySelector('.word-likes');
    if (countElement) {
      countElement.textContent = `❤️ ${new Intl.NumberFormat('de-DE').format(count)}`;
    }
  };

  fetch(`/api.php?action=get_list_likes&slug=${encodeURIComponent(postId)}`)
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(`Unable to load word likes (${response.status}).`);
      }

      return response.json();
    })
    .then((data) => {
      if (!data.success || typeof data.likes !== 'object' || data.likes === null) {
        throw new Error(data.message || 'Unable to load word likes.');
      }

      rows.forEach((row) => {
        const word = row.querySelector('[data-word]')?.dataset.word;
        if (word) {
          updateLikeCount(row, Number(data.likes[word] ?? 0));
        }
      });
    })
    .catch((error) => {
      console.error('Error loading word likes:', error);
    });

  rows.forEach((row) => {
    const button = row.querySelector('[data-word]');
    const word = button?.dataset.word;
    if (!button || !word) {
      return;
    }

    button.addEventListener('click', async () => {
      button.disabled = true;

      try {
        const response = await fetch(
          `/api.php?action=save_list_like&slug=${encodeURIComponent(postId)}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ word }),
          },
        );
        const data = await response.json();

        if (!response.ok || !data.success || !Number.isFinite(Number(data.likes))) {
          throw new Error(data.message || `Unable to save word like (${response.status}).`);
        }

        updateLikeCount(row, Number(data.likes));
      } catch (error) {
        console.error('Error saving word like:', error);
        button.disabled = false;
      }
    });
  });

  const render = (sortedRows) => {
    sortedRows.forEach((row) => table.appendChild(row));
  };

  const sortAlphabetically = () => {
    render([...rows].sort((a, b) => (
      a.dataset.name.localeCompare(b.dataset.name, 'de', { sensitivity: 'base' })
    )));
  };

  const sortByLikes = () => {
    render([...rows].sort((a, b) => Number(b.dataset.likes) - Number(a.dataset.likes)));
  };

  sortButtons.forEach((button) => {
    button.addEventListener('click', () => {
      sortButtons.forEach((sortButton) => sortButton.classList.remove('active'));
      button.classList.add('active');

      if (button.dataset.sort === 'likes') {
        sortByLikes();
      } else {
        sortAlphabetically();
      }
    });
  });

  searchInput.addEventListener('input', () => {
    const search = searchInput.value.trim().toLocaleLowerCase('de');

    rows.forEach((row) => {
      row.hidden = search !== '' && !row.dataset.name.includes(search);
    });
  });
});
